module.exports = __webpack_public_path__ + "static/media/sensor-on.cf3d0716.svg";